import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { of, filter, concatMap, finalize, Subscription, Subject } from 'rxjs';
import { tap, map, switchMap, debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

import { Person } from 'src/app/shared/person';
import { Client } from 'src/app/shared/client';
import { Document } from 'src/app/shared/document';

import { ClientApiService } from 'src/app/services/client-api.service';

@Component({
  selector: 'app-new-document-dlg-companies-receipt',
  templateUrl: './new-document-dlg-companies-receipt.component.html',
  styleUrls: ['./new-document-dlg-companies-receipt.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NewDocumentDlgCompaniesReceiptComponent implements OnInit, OnChanges, OnDestroy {

  @Input() parentDocument: Document = null;
  @Input() newDocument: Document = null;

  @Input() cliComLabel: string = 'Получатель продукции:';
  @Input() cliPerLabel: string = 'Ответственный в компании:';
  @Input() pcoComLabel: string = 'Юридическое лицо получателя продукции:';
  @Input() pcoPerLabel: string = 'Ответственный получателя:';
  @Input() manDepLabel: string = 'Отдел - получатель продукции компании:';
  @Input() pcoDepLabel: string = 'Отдел - получатель продукции юрлица:';

  private _cliCompanyQuery: Subscription = null;
  private _depChildQuery: Subscription = null;

  private _newDocumentUpdateQuery: Subscription = null;

  cliCompany: Client = null;
  pcoCompany: Client = null;
  cliPerson: Person = null;
  pcoPerson: Person = null;

  private cliCompanySubs$ = new Subject<number>();
  private newDocumentUpdateSubs$ = new Subject<Document>();
  @Output() newDocumentUpdate: EventEmitter<Document> = new EventEmitter();

  parentDocumentId: number = null;

  selectDepartmentOn: boolean = true;   // Just to keep compatibility (kind of)
  constructor(
    private cliApi: ClientApiService,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    //console.log('*** NewDocumentDlgCompaniesReceiptComponent ngOnChanges:');
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** NewDocumentDlgCompaniesReceiptComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));
      //console.log('*** NewDocumentDlgCompaniesReceiptComponent ngOnChanges ' + propName + ' (was):    ' + JSON.stringify(change.previousValue));

    //  switch (propName) {
    //    case 'parentDocument':
    //      break;
    //  }
    }
  }

  ngOnDestroy(): void {
    console.log('*** NewDocumentDlgCompaniesReceiptComponent in ngOnDestroy')

    if (this._cliCompanyQuery) { this._cliCompanyQuery.unsubscribe(); }
    if (this._depChildQuery) { this._depChildQuery.unsubscribe(); }
    if (this._newDocumentUpdateQuery) { this._newDocumentUpdateQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    console.log('*** NewDocumentDlgCompaniesReceiptComponent in ngOnInit');

    this._newDocumentUpdateQuery =
      this.newDocumentUpdateSubs$.pipe(
        debounceTime(50),
        distinctUntilChanged(),
        tap(document => environment.production || console.log('*** NewDocumentDlgCompaniesReceiptComponent newDocumentUpdateSubs$: ' + JSON.stringify(document))),
        map(document => this.newDocumentUpdate.emit(document)),
      )
        .subscribe();

    this._cliCompanyQuery =
      this.cliCompanySubs$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        switchMap(cli => this.cliApi.getClientById(cli).pipe(

          map(cliCompany => {
            console.log('*** NewDocumentDlgCompaniesReceiptComponent cliCompanySubs$: ' + JSON.stringify(cliCompany));

            this.cliCompany = cliCompany[0];

            if (this.newDocument && this.cliCompany && this.cliCompany.CURID) {
              this.newDocument.DOCCURRID = this.cliCompany.CURID;
              this.newDocumentUpdateSubs$.next(this.newDocument);
            }
        }))))
        .subscribe();
  }

  cliCompanySelected(event) {
    console.log('*** NewDocumentDlgCompaniesReceiptComponent cliCompanySelected  ' + JSON.stringify(event));
    this.newDocument.DOCCLIENTSID = event;
    this.newDocument.DOCPCOCLIID = event;

    this.cliCompanySubs$.next(this.newDocument.DOCCLIENTSID);
  }

  cliPersonSelected(event) {
    console.log('*** NewDocumentDlgCompaniesReceiptComponent cliPersonSelected  ' + JSON.stringify(event));
    this.newDocument.DOCPERSONID = event;
    this.newDocumentUpdateSubs$.next(this.newDocument);
  }

  pcoCompanySelected(event) {
    console.log('*** NewDocumentDlgCompaniesReceiptComponent pcoCompanySelected  ' + JSON.stringify(event));
    this.newDocument.DOCPCOCLIID = event;

    this._depChildQuery =
      this.cliApi.getChildDepartmentsById(this.newDocument.DOCCLIDEPID, this.newDocument.DOCPCOCLIID)
      .pipe(
        concatMap(data => {
          this.newDocument.DOCPCODEPID = data[0].CLIID;

          return this.cliApi.getPersonsByClientId(this.newDocument.DOCPCOCLIID);
        }),

        tap(dir => environment.production || console.log('*** NewDocumentDlgCompaniesReceiptComponent pcoCompanySelected getPersonsByClientId(ndi.DOCPCOCLIID): ' + JSON.stringify(dir))),
        filter(prs => (prs && prs.length > 0)),

        concatMap(prs => {

          let dir: Person = prs.sort((a, b) => (b.PERSRESPONSIBLE - a.PERSRESPONSIBLE)).find(pr => pr.PERSRESPONSIBLE > 0);

          if (dir) {
            this.newDocument.DOCPCOPERID = dir.PERSID;
          } else
            if (prs.length > 0) {
              this.newDocument.DOCPCOPERID = prs[0].PERSID;
            }
          return of(this.newDocument);
        }),

        tap(document => this.newDocumentUpdateSubs$.next(document))
      )
        .subscribe();
  }

  pcoPersonSelected(event) {
    console.log('*** NewDocumentDlgCompaniesReceiptComponent pcoPersonSelected  ' + JSON.stringify(event));
    if (event) {
      this.newDocument.DOCPCOPERID = event;
      this.newDocumentUpdateSubs$.next(this.newDocument);
    }
  }

  mainStockSelected(selectedId) {
    console.log('*** NewDocumentDlgCompaniesReceiptComponent in mainStockSelected: ' + selectedId);

    this.newDocument.DOCCLIDEPID = selectedId;

    this._depChildQuery =
      this.cliApi.getChildDepartmentsById(this.newDocument.DOCCLIDEPID, this.newDocument.DOCPCOCLIID)
      .pipe(
        map(data => this.newDocument.DOCPCODEPID = data[0].CLIID),
        finalize(() => this.newDocumentUpdateSubs$.next(this.newDocument))
        )
        .subscribe();
  }

  childStockSelected(selectedId) {
    console.log('*** NewDocumentDlgCompaniesReceiptComponent in childStockSelected: ' + selectedId);

/*
 * TODO: In general it is not good idea to select the LCO department
 * 
 * it usually selected by Main Department
 */
    this.newDocument.DOCPCODEPID = selectedId;
    this.newDocumentUpdateSubs$.next(this.newDocument);
  }
}
